import { View } from "react-native"
import BFText, { H4, H6 } from "@/components/standard/BFText"
import { BFColors } from "@/constants/Colors"
import { type ReactNode } from "react"
import Tooltip from "rn-tooltip"
import InfoIcon from "@/assets/icons/tooltip-i-notfilled.svg"
import EditButton from "@/components/buttons/EditButton"

export interface SummaryItemProps {
  label: string
  value?: string | null
  displays?: Record<string, string>
  tooltip?: string | ReactNode
  testID?: string
  tight?: boolean
  bolded?: boolean
  onEditPress?: () => void
  buttonText?: string
}

export default function SummaryItem({
  label,
  value,
  displays,
  tooltip,
  testID,
  tight = false,
  bolded = false,
  onEditPress,
  buttonText,
}: SummaryItemProps) {
  const LabelComponent = bolded ? H6 : BFText
  const ValueComponent = bolded ? H4 : BFText

  return (
    <View
      className={`flex flex-row justify-between items-center ${tight ? "py-1" : "py-2"}`}
    >
      <View className="flex flex-row items-center">
        <LabelComponent
          {...(LabelComponent === BFText && {
            className: "font-spacegrotesk text-midnight-blue text-[14px]",
          })}
        >
          {label}
          {tooltip && (
            <Tooltip
              popover={
                <BFText className="font-spacegrotesk text-white text-[12px] p-[2px]">
                  {tooltip}
                </BFText>
              }
              actionType="press"
              backgroundColor={BFColors.calmBlue}
              withOverlay={false}
              height={"auto"}
              width={250}
              containerStyle={{
                borderRadius: 2,
              }}
              toggleWrapperProps={{
                hitSlop: 12,
              }}
            >
              <View>
                <InfoIcon width={16} height={16} />
              </View>
            </Tooltip>
          )}
        </LabelComponent>
        {onEditPress && (
          <View className="mt-px ml-3">
            <EditButton onPress={onEditPress} buttonText={buttonText} />
          </View>
        )}
      </View>

      <ValueComponent
        testID={testID}
        {...(ValueComponent === BFText && {
          className: "font-figtree-bold text-midnight-blue text-[14px]",
        })}
      >
        {value ? (displays ? displays[value] : value) : "-"}
      </ValueComponent>
    </View>
  )
}
